import React from "react";
import image_3 from "../../images/afro-academy/Picture3.png";

const Header = () => {
  return (
    <header>
      <div className="text-center pt-7 pb-7">
        <h3 className="fs-56 lh-64 gilroy-bold pb-7">In partnership With</h3>
        <div>
          <img src={image_3} className="img-fluid" loading="lazy" alt="" />
        </div>
      </div>
    </header>
  );
};

export default Header;
